var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"attempt-icon",style:({background: _vm.colors[_vm.colors.theme].from})},[_c('p',{style:({color: _vm.colors.theme == 'dark' ? '#fff' : '#000'})},[_vm._v("3")])])}
var staticRenderFns = []

export { render, staticRenderFns }